window.$ = require('jquery');
window.jQuery = window.$;
window.Swal = require('sweetalert2')
require('./bootstrap');
require('./yole');
window.toastr = require('toastr')
import 'toastr/toastr.scss'
